const passwordLength = 8;
const alphabetRegex = /^[A-Za-z\s]+$/;
const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const validateLoginForm = (data) => {
  const errors = {};
  if (!data.email?.trim()) {
    errors.email = "Email is required.";
  } else if (!emailRegex.test(data.email)) {
    errors.email = "Email is invalid.";
  }
  if (!data.password) {
    errors.password = "Password is required.";
  }
  return errors;
};

export const validateSignUpForm = (data) => {
  const errors = {};
  if (!data.firstName?.trim()) {
    errors.firstName = "First name is required.";
  } else if (!alphabetRegex.test(data.firstName)) {
    errors.firstName = "First name only accept alphabetic character.";
  }
  if (!data.lastName?.trim()) {
    errors.lastName = "Last name is required.";
  } else if (!alphabetRegex.test(data.lastName)) {
    errors.lastName = "Last name only accept alphabetic character.";
  }
  if (!data.email?.trim()) {
    errors.email = "Email is required.";
  } else if (!emailRegex.test(data.email)) {
    errors.email = "Email is invalid.";
  }
  if (!data.password) {
    errors.password = "Password is required.";
  } else if (data.password.length < passwordLength) {
    errors.password = `Password must be at least ${passwordLength} characters long.`;
  }
  if (!data.confirmPassword) {
    errors.confirmPassword = "Confirm password is required.";
  } else if (data.confirmPassword !== data.password) {
    errors.confirmPassword = "Passwords and Confirm password are not matched.";
  }
  if (!data.contactNum?.trim()) {
    errors.contactNum = "Contact number is required.";
  }
  return errors;
};

export const validateForgotPasswordForm = (data) => {
  const errors = {};
  if (!data.email?.trim()) {
    errors.email = "Email is required.";
  } else if (!emailRegex.test(data.email)) {
    errors.email = "Email is invalid.";
  }
  return errors;
};
